import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './assets/css/tax.css';
import TaxList from './components/TaxList';
import TaxDetails from './components/TaxDetails';

const App = () => {
    const [addNew, setAddNew] = useState(false);
    //const [taxClasses, setTaxClasses] = useState(false);
    const [TaxIdToEdit, setTaxIdToEdit] = useState(null);

    const handleEdit = (id) => {
        setAddNew(true);
        setTaxIdToEdit(id);
    };

    const handleAddNew = () => {
        setAddNew(true);
        //setTaxClasses(true); 
    };

    return (
        <>
            <div className="flex items-center gap-8">
                <p className="text-ec-body font-medium font-inter lg:text-xl md:text-lg leading-8">
                    {addNew ? 'Add Tax Class' : ''}
                </p>
            </div>

            {!addNew && (
                <TaxList
                    handleEdit={handleEdit}
                    handleAddNew={handleAddNew}
                />
            )}
            {addNew && (
                <TaxDetails
                    hideAddNew={() => setAddNew(false)}
                    taxId={TaxIdToEdit}
                />
            )}
            <ToastContainer />
        </>
    );
};

const container = document.getElementById('easycommerce-tax-classes');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}

export default App;
